// const hostName = "http://localhost";
const hostName = "https://instabooking-backend.onrender.com";
export default hostName;